import { render } from "./preference.vue?vue&type=template&id=1bf17a00&scoped=true"
import script from "./preference.vue?vue&type=script&lang=js"
export * from "./preference.vue?vue&type=script&lang=js"

import "./preference.vue?vue&type=style&index=0&id=1bf17a00&scoped=true&lang=css"

import exportComponent from "/home/runner/work/iam-atkomst-web/iam-atkomst-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf17a00"]])

export default __exports__